import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { SessionProvider } from "./auth/session";
import { router } from "./router";
import { queryClient } from "./state/queryClient";
import { persistOptions } from "./state/queryPersist";
import { useUiStore } from "./state/uiStore";

// Provider-Komposition: Server-State (TanStack Query, D149 mit localStorage-Persistenz →
// Sofort-Paint beim Reload) > Identität (SessionProvider) > Routing. Das Theme (§11) wird als
// `.light`-Klasse an <html> gespiegelt.
export function App() {
  const theme = useUiStore((s) => s.theme);
  useEffect(() => {
    document.documentElement.classList.toggle("light", theme === "light");
  }, [theme]);

  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <SessionProvider>
        <RouterProvider router={router} />
      </SessionProvider>
    </PersistQueryClientProvider>
  );
}
